import script from "./StoryblockDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryblockDescription.vue?vue&type=script&setup=true&lang=ts"

import "./StoryblockDescription.vue?vue&type=style&index=0&id=63731724&lang=css"

const __exports__ = script;

export default __exports__